import { ElementType } from 'react';

import { mergeSx } from '../../utils/styling';
import { Typography } from '../../components-v2/Typography';
import type { TypographyProps } from '../../components-v2/Typography';
import { tokens } from '../../theme/generated/tokens';

type LinkBehaviourProps<C extends ElementType = 'p'> = TypographyProps<
  C,
  {
    component?: C | 'p';
    secondaryAction?: boolean;
    disabled?: boolean;
    testId?: string;
  }
>;

export const LinkBehaviour = <C extends ElementType = 'p'>({
  secondaryAction,
  sx,
  testId,
  color = tokens.theme.fg.action.primary,
  disabled,
  onClick,
  ...props
}: LinkBehaviourProps<C>) => {
  return (
    <Typography
      variant="inherit"
      sx={mergeSx(
        !disabled ? { cursor: 'pointer' } : undefined,
        secondaryAction && {
          '&:hover': {
            color: tokens.theme.fg.action.primaryHover,
          },
        },
        sx
      )}
      color={!disabled ? color : undefined}
      onClick={!disabled ? onClick : undefined}
      data-testid={testId}
      {...props}
    />
  );
};
